<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="mb-3 w-full lg:w-5/6">
                <div class="mb-3 w-full lg:w-5/6" :class="{ 'has-error': form.errors.has('organization_id') }">
                    <label class="mb-1" for="organization_id">{{ $t('globals.organization') }}</label>
                    <select class="custom-select" id="organization_id" name="organization_id" v-model="form.organization_id" @change="form.errors.forget($event.target.name)">
                        <option v-for="organization in organizations" :value="organization.id">{{ organization.name }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('organization_id')" v-text="form.errors.get('organization_id')"></p>
                </div>
                <div class="lg:w-5/6 w-full">
                    <label class="mb-1">{{ $t('invoices.products') }}</label>
                    <div class="mb-3">
                        <button @click="addProduct()" class="bg-primary-100 border-primary-400 btn btn-primary btn-sm hover:bg-primary-200 px-10 text-primary-500" type="button">
                            {{ $t('invoices.add_product') }}
                        </button>
                    </div>
                    <div class="bg-gray-100 border-gray-input-border card mb-3" v-for="(product, productKey) in form.products">
                        <div class="absolute top-0 right-0 z-50 overflow-auto flex">
                            <button @click="removeProduct(productKey)" class="btn btn-outline-danger btn-xs group mr-2 mt-2" type="button" v-tooltip="{ content: $t('invoices.remove_product') }">
                                <span class="icon icon-trash text-danger-500 group-hover:text-white"></span>
                            </button>
                        </div>
                        <div class="card-body space-y-3">
                            <div :class="{ 'has-error': form.errors.has(`products.${productKey}.custom_description`) }">
                                <label :for="`products.${productKey}.custom_description`" class="mb-1">{{ $t('organization_payments.description') }}</label>
                                <textarea class="form-control lg:w-3/4 w-full" :id="`products.${productKey}.custom_description`" :name="`products.${productKey}.custom_description`" rows="2" v-model="form.products[productKey].custom_description" @keydown="form.errors.forget($event.target.name)"></textarea>
                                <p class="help-block text-danger-500" v-if="form.errors.has(`products.${productKey}.custom_description`)" v-text="form.errors.get(`products.${productKey}.custom_description`)"></p>
                            </div>
                            <div :class="{ 'has-error': form.errors.has(`products.${productKey}.total`) }">
                                <label :for="`products.${productKey}.total`" class="mb-1">{{ $t('organization_payments.price') }}</label>
                                <input class="form-control lg:w-3/4 w-full" :id="`products.${productKey}.total`" :name="`products.${productKey}.total`" type="text" v-model="form.products[productKey].total" @keydown="form.errors.forget($event.target.name)" />
                                <p class="help-block text-danger-500" v-if="form.errors.has(`products.${productKey}.total`)" v-text="form.errors.get(`products.${productKey}.total`)"></p>
                            </div>
                        </div>
                    </div>
                    <p class="help-block text-danger-500" v-if="form.errors.has('products')" v-text="form.errors.get('products')"></p>
                </div>
            </div>
            <div class="pt-2">
                <button class="btn btn-primary" :disabled="form.errors.any()" type="submit">
                    {{ $t('globals.save') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        organizations: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            form: new Form({
                organization_id: null,
                products: [
                    {
                        custom_description: null,
                        total: null,
                    },
                ],
            }),
        };
    },

    methods: {
        addProduct() {
            this.form.products.push({
                custom_description: null,
                total: null,
            });
            this.form.errors.forget('products');
        },

        removeProduct(productKey) {
            this.form.products.splice(productKey, 1);
            this.form.errors.forget('products');
            this.form.errors.forget(`products.${productKey}.custom_description`);
            this.form.errors.forget(`products.${productKey}.total`);
        },

        onSubmit() {
            Globals.post('/kiosk/invoices', this.form)
                .then(() => {
                    const flash = {
                        type: 'success',
                        message: this.$t('invoices.added'),
                    };
                    window.sessionStorage.setItem('flash', JSON.stringify(flash));
                })
                .then(() => window.location.href = '/kiosk/invoices')
                .catch(error => {
                    if (error.message !== 'The given data was invalid.') {
                        window.toastr.clear();
                        window.toastr.error(this.$t('globals.unexpected_error'));
                    }
                });
        },
    },
};
</script>
